import React from 'react';
import { useLocation } from 'react-router';

const getBooleanValue = (value) => {
  if (!value) return false;
  if (typeof value === 'boolean') return value;
  if (typeof value !== 'string') return false;
  return value.toLowerCase() === 'true';
}

export const useGlobalVariable = (name, urlName=name, toBoolean=true, readFromGlobal=false) => {
  const { search } = useLocation();
  const urlSearchParams = new URLSearchParams(search);
  let initialValue = urlSearchParams.get(urlName) || window[name] || null;
  if (readFromGlobal) {
    initialValue = window[name] || urlSearchParams.get(urlName) || null
  }
  const [state, setState] = React.useState(initialValue);
  
  return [toBoolean ? getBooleanValue(state) : state, setState];
}